import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LOCIZE_NS } from '../../constants/common';
import { cn } from '../../utils/cn';
import { Text } from '../Text';

const EMPTY_STATE_COPY = {
  emptyDates: {
    titleKey: 'AppointmentsReserve.Steps.session.dateTime.emptyDates.title',
    descriptionKey: 'AppointmentsReserve.Steps.session.dateTime.emptyDates.description',
  },
  emptySlots: {
    titleKey: 'AppointmentsReserve.Steps.session.dateTime.emptySlots.title',
    descriptionKey: 'AppointmentsReserve.Steps.session.dateTime.emptySlots.description',
  },
} as const;

interface AppointmentsEmptyCalendarProps {
  variant: keyof typeof EMPTY_STATE_COPY;
  className?: string;
}

export const AppointmentsEmptyCalendar = ({
  variant,
  className,
}: AppointmentsEmptyCalendarProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { titleKey, descriptionKey } = EMPTY_STATE_COPY[variant];

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-1 text-center',
        className
      )}
    >
      <Text variant="text-sm-regular" className="text-denim-500">
        {t(titleKey)}
      </Text>
      <Text variant="text-xs-regular" className="text-gray-500">
        {t(descriptionKey)}
      </Text>
    </div>
  );
};
